import React from 'react';
import { Button } from '../ui/button';

const Header = ({ isScrolled, scrollToContact }) => {
  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out ${
      isScrolled 
        ? 'bg-[#0B0F1A]/98 backdrop-blur-xl py-5 border-b border-[#2F6BFF]/20 shadow-2xl shadow-[#2F6BFF]/5' 
        : 'bg-transparent py-7 border-b border-transparent'
    }`}>
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 group">
            <div className="relative flex items-center">
              <img 
                src="/logo.png" 
                alt="MeshWeb" 
                className="w-10 h-10 object-contain"
                style={{
                  filter: 'drop-shadow(0 0 8px rgba(47, 107, 255, 0.3))'
                }} 
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#2F6BFF]/20 to-[#4DA3FF]/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </div>
            <span className="text-xl font-semibold text-white tracking-tight leading-none">
              MeshWeb
            </span>
          </div>
          
          <nav className="hidden md:flex items-center gap-10">
            <a 
              href="#services" 
              className="text-[#F5F7FF]/90 hover:text-[#3b82f6] transition-all duration-200 font-medium text-[15px] relative group"
            >
              Services
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] group-hover:w-full transition-all duration-200"></span>
            </a>
            <a 
              href="#portfolio" 
              className="text-[#F5F7FF]/90 hover:text-[#3b82f6] transition-all duration-200 font-medium text-[15px] relative group"
            >
              Portfolio
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] group-hover:w-full transition-all duration-200"></span>
            </a>
            <a 
              href="#pricing" 
              className="text-[#F5F7FF]/90 hover:text-[#3b82f6] transition-all duration-200 font-medium text-[15px] relative group"
            >
              Pricing
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] group-hover:w-full transition-all duration-200"></span>
            </a>
            <a 
              href="#faq" 
              className="text-[#F5F7FF]/90 hover:text-[#3b82f6] transition-all duration-200 font-medium text-[15px] relative group"
            >
              Help
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] group-hover:w-full transition-all duration-200"></span>
            </a>
            <Button 
              onClick={scrollToContact} 
              className="relative bg-gradient-to-r from-[#2F6BFF] to-[#4DA3FF] hover:from-[#4DA3FF] hover:to-[#2F6BFF] text-white font-semibold px-7 py-3 rounded-xl hover:scale-105 transition-all duration-300 shadow-lg shadow-[#2F6BFF]/40 hover:shadow-2xl hover:shadow-[#4DA3FF]/50 overflow-hidden group"
            >
              <span className="relative z-10">Get Started</span>
              <div className="absolute inset-0 bg-gradient-to-r from-[#4DA3FF] to-[#2F6BFF] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
